// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"error-view__wrapper3lm","image":"error-view__image2-u","button":"error-view__button1t6","copy":"error-view__copy3gC","link":"error-view__link1_u"};